//import { createStore, applyMiddleware } from "redux";
import { createStore} from "redux";
//import { composeWithDevTools } from "redux-devtools-extension";
import combineReducers from "../reducers/index";


const store = createStore(combineReducers)
/*
const store = createStore(combineReducers, composeWithDevTools(applyMiddleware(logger)));
*/
export default store;
